/**
 * Returns the colorId for use in a URL query parameter.
 * Generic color IDs (prefixed with 'generic_') are excluded from URLs
 * as they are not meaningful for appraisal links.
 *
 * @param {string|number|undefined} colorId - The color ID to evaluate
 * @returns {string|number|undefined} The colorId if valid, undefined if generic
 */
export const getColorIdForUrl = colorId => {
  if (colorId?.toString().includes('generic_')) {
    return undefined;
  }
  return colorId;
};
